<template>
  <div class="a-vs-main--tab-panel">
    <div class="a-vs-main--row">
       <stake-table
        class="a-vs-main--row__table"
        :type='2'
        :matchNo="match.MatchNo"
        :activeStake="eventData.activeStake"
        :isBetPlaced="eventData.isBetPlaced"
        :isBettingEnabled="eventData.isBettingEnabled"
        :stakes="match.Stakes" />

      <stake-table
        class="a-vs-main--row__table"
        :type='1'
        :activeStake="eventData.activeStake"
        :matchNo="match.MatchNo"
        :isBetPlaced="eventData.isBetPlaced"
        :isBettingEnabled="eventData.isBettingEnabled"
        :stakes="match.Stakes" />
    </div>

    <div class="a-vs-main--grid-row">
      <div class="a-vs-main--grid-row__grid-col">
        <stake-table
          class="a-vs-main--grid-row__grid-col--table merged-table"
          :type='3'
          :activeStake="eventData.activeStake"
          :matchNo="match.MatchNo"
          :isBetPlaced="eventData.isBetPlaced"
          :isBettingEnabled="eventData.isBettingEnabled"
          :stakes="match.Stakes"/>
      </div>

      <div class="a-vs-main--grid-row__grid-col correct-score">
        <stake-table
          class="a-vs-main--grid-row__grid-col--table"
          :type='5'
          :activeStake="eventData.activeStake"
          :matchNo="match.MatchNo"
          :isBetPlaced="eventData.isBetPlaced"
          :isBettingEnabled="eventData.isBettingEnabled"
          :stakes="match.Stakes" />
      </div>
    </div>
  </div>
</template>

<script>
import { eventBus } from '@/main.js'
import EventConstants from '@/constants/Events'

export default {
  props: {
    eventData: {
      type: Object,
      required: true
    },
    isMobileDesign: {
      type: Boolean,
      required: true
    }
  },
  created: function () {
    eventBus.$on(EventConstants.VSOCCER_SELECTED_STAKE, this.selectedActiveStake)
  },
  beforeDestroy () {
    eventBus.$off(EventConstants.VSOCCER_SELECTED_STAKE, this.selectedActiveStake)
  },
  methods: {
    selectedActiveStake: function (stake) {
      this.eventData.activeStake = stake
    },
    onReset: function () {
      if (this.eventData.isBettingEnabled && !this.eventData.isBetPlaced) {
        this.eventData.activeStake = null
      }
    },
    onConfirm: function () {
      if (this.eventData.isBettingEnabled && this.eventData.activeStake) {
        if (!this.eventData.isBetPlaced) {
          eventBus.onConfirmMatch(this.eventData)
          this.eventData.isBetPlaced = true
        }
      }
    }
  },
  computed: {
    match: function () {
      return this.eventData.Matches[0]
    },
    isButtonResetAndConfirmActive: function () {
      return !this.eventData.isBetPlaced && this.eventData.isBettingEnabled
    },
    roundNumber: function () {
      return this.eventData.EventID % 1000
    }
  }
}
</script>
